import * as React from 'react';
import {useSelector} from 'react-redux';
import {Link as RouterLink} from 'react-router-dom';

import {Session} from 'nutshell-core/session';
import type {User} from 'nutshell-core/types';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {NutshellState} from '../../../store';

import {ChatWithUs} from './chat-with-us';
import {useGetPersonalizedDemo} from './graphql/hooks/use-get-personalized-demo';

export function TrialBanner() {
    const loggedInUser: User | null | undefined = useSelector((state: NutshellState) =>
        Session.getSessionStateUser(state)
    );
    const {personalizedDemo} = useGetPersonalizedDemo();

    return (
        <div className='nut-trial-banner--container'>
            <div className='nut-trial-banner--content'>
                <div className='nut-trial-banner--content-left-section'>
                    <StackLegacy spacing={0}>
                        <Body color='white' size='small'>
                            Your trial has{' '}
                            <strong>
                                {NutClientConfig.daysLeftInTrial} day
                                {NutClientConfig.daysLeftInTrial !== 1 && 's'}
                            </strong>{' '}
                            remaining
                        </Body>
                        {loggedInUser && loggedInUser.permissions.canAccessBilling && (
                            <Link
                                // @ts-expect-error
                                as={RouterLink}
                                size='small'
                                to='/setup/billing/sales'
                                variant='primary'
                            >
                                Upgrade now
                            </Link>
                        )}
                    </StackLegacy>
                    {personalizedDemo ? (
                        <div className='mx-12'>
                            {/* @ts-expect-error */}
                            <Link variant='button-primary' as={RouterLink} to='/sales-demo'>
                                Get a personal demo
                            </Link>
                        </div>
                    ) : undefined}
                </div>
                <ChatWithUs />
            </div>
        </div>
    );
}
